export default "__VITE_ASSET__Rd0pmETg__"